import React from "react";
import { useNavigate } from "react-router-dom";

const MainAdminComponent = () => {
  let navigate = useNavigate();
  return (
    <>
      <button
        className="px-4 py-2 w-full text-sm text-left text-gray-600 hover:bg-gray-100"
        onClick={() => {
          navigate("/financials");
        }}
      >
        Financial Year
      </button>
      <button
        className="px-4 py-2 w-full text-sm text-left text-gray-600 hover:bg-gray-100"
        onClick={() => {
          navigate("/churches");
        }}
      >
        Church List
      </button>
      <button
        className="px-4 py-2 w-full text-sm text-left text-gray-600 hover:bg-gray-100"
        onClick={() => {
          navigate("/dioceseslist");
        }}
      >
        Diocese List
      </button>
      <button
        className="px-4 py-2 w-full text-sm text-left text-gray-600 hover:bg-gray-100"
        onClick={() => {
          navigate("/users");
        }}
      >
        Users Management
      </button>
      <button
        className="px-4 py-2 w-full text-sm text-left text-gray-600 hover:bg-gray-100"
        onClick={() => {
          navigate("/roles");
        }}
      >
        Role List
      </button>
    </>
  );
};

export default MainAdminComponent;
